import { render } from "./PrinterDisplayNewsCmp.vue?vue&type=template&id=27a33420"
import script from "./PrinterDisplayNewsCmp.vue?vue&type=script&lang=js"
export * from "./PrinterDisplayNewsCmp.vue?vue&type=script&lang=js"

import "./PrinterDisplayNewsCmp.vue?vue&type=style&index=0&id=27a33420&lang=css"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__